import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LoadingMoreTechniciansIndicatorProps {
  loading: boolean
  className?: string
  spinnerClassName?: string
}

export function LoadingMoreTechniciansIndicator({
  loading,
  className,
  spinnerClassName,
}: LoadingMoreTechniciansIndicatorProps) {
  return (
    <div
      className={cn(
        'flex min-w-[60px] shrink-0 items-center justify-center',
        className
      )}
      aria-live='polite'
      aria-busy={loading}
    >
      {loading && (
        <Loader2
          className={cn(
            'h-5 w-5 animate-spin text-muted-foreground',
            spinnerClassName
          )}
        />
      )}
    </div>
  )
}
